import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { QuamCalendarWorkroom } from './index'

/**
 * V2 Quam Calendar Workroom — route wrapper.
 *
 * Registered standalone + auth-gated (see router.tsx):
 *   /square/command-center/calendar
 *
 * Opened by the "Calendar" nav button on the V2 command center.
 *
 * Honesty contract (PHASE_2M D3, corrected): the workroom is fully live-wired —
 * the month grid, day briefing, and event workspace render ONLY real backend
 * records (Google events, drafts, plans, Daily calls, daily-meeting records, due
 * tasks) via useQuamCalendar; there is NO localStorage/session-storage adapter.
 * Google Calendar shows its real connection state (drafts save without it;
 * committing requires connecting); the notes/links/files/messages spine reports
 * the exact MIGRATION_APPROVAL_REQUIRED state until 20260711000001 is applied;
 * files use real signed upload/download URLs. A "Priority Matrix" (Eisenhower)
 * view groups due-dated tasks by importance × urgency over the SAME live data —
 * a read-only, replaceable classification that never writes or reprioritizes.
 * Nothing is faked, sealed, or executed offline.
 */
export default function SquareCodeCalendarRoute() {
  const navigate = useNavigate()
  return (
    <QuamCalendarWorkroom
      onExit={() => navigate(COMMAND_CENTER_ROOT)}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onOpenPath={(path: string) => navigate(path)}
    />
  )
}
